const changelog = [
  {
    version: "3.4.0",
    date: "2026-07-24",
    changes: [
      "🆕 Modelos visuais de receituário simples (catálogo): no receituário comum agora dá pra escolher um 'Modelo visual' pronto e bonito (começando pelo Teal · Caduceu) — o sistema monta o receituário em cima da arte real, colocando o nome, conselho, especialidade e contatos do profissional automaticamente. O rodapé mostra só os contatos preenchidos (telefone, email, endereço), cada um com seu ícone",
      "Campo de e-mail do profissional no receituário comum, pra sair no rodapé dos modelos",
      "🔧 Correção de conexão do WhatsApp: a tela de Conexões podia mostrar 'Conectado' ou 'Conectando...' errado, mesmo com a sessão caída ou o QR pronto pra escanear. Agora o status mostrado reflete o estado real, o botão de 'Conectando' permite pedir um QR novo, e a verificação de conexão dá tempo suficiente pro WhatsApp sincronizar depois do scan antes de decidir se deu certo",
    ],
  },
  {
    version: "3.3.1",
    date: "2026-07-24",
    changes: [
      "Receituário simples (comum) mais limpo: quando você escolhe o modelo 'comum', o formulário esconde tudo que é do talão controlado (importar autorização da VISA, faixa de numeração, CPF do prescritor, 'impresso em nome de') — sobra só o que o bloquinho simples precisa, sem a confusão de antes",
    ],
  },
  {
    version: "3.3.0",
    date: "2026-07-24",
    changes: [
      "🆕 Prévia ao vivo do receituário: ao editar um receituário no modal, uma prévia da página aparece do lado e atualiza sozinha conforme você digita — sem precisar gerar o arquivo e sem consumir a numeração da faixa. Dá pra conferir o resultado antes de fechar",
    ],
  },
  {
    version: "3.2.0",
    date: "2026-07-24",
    changes: [
      "🆕 Alívio de disco automático: mídia antiga do chat (mais de 7 dias) passa a viver só no Google Drive, liberando espaço no servidor — as conversas antigas continuam abrindo normalmente, o sistema busca o arquivo do Drive quando necessário",
      "🆕 Envio de arquivos do CorelDraw (.cdr), ZIP e RAR agora é aceito no chat, além de PDFs de aplicativos de scanner que antes eram recusados",
      "Limite de tamanho de arquivo aumentado para 150MB (era 20MB) — artes pesadas e vídeos agora passam sem erro",
      "Fix: editar o nome ou perfil de um atendente sem trocar a senha não pede mais a senha atual à toa; o cadastro de usuário ficou mais limpo e organizado",
      "Mensagens de erro de upload agora explicam o motivo em português (tipo não aceito, arquivo grande demais) em vez de um erro genérico",
    ],
  },
  {
    version: "3.1.0",
    date: "2026-07-21",
    changes: [
      "🆕 Pasta do cliente no Google Drive: ao aceitar um atendimento, o sistema oferece criar a pasta do cliente (padrão Nome - Telefone) já organizada com subpastas de documentos, chat e pedidos — marque 'sempre criar automaticamente' pra nem precisar confirmar",
      "🆕 Aba 'Arquivos (Drive)' no painel do contato: navegue pelas pastas do cliente, baixe e envie arquivos sem sair do chat — tudo fica guardado na conta Google da empresa, organizado e acessível pra equipe",
      "🆕 Produção → Drive automático: ao marcar um adesivo como IMPRESSO, o PDF de impressão, a arte, a prova e o arquivo de corte sobem sozinhos pra pasta do cliente (02 - Pedidos/ADE-…) — reimprimir não duplica nada",
      "🆕 Receituário controlado: ao marcar impresso, um registro de emissão (faixa numerada + autorização VISA) fica arquivado na pasta do cliente pra consulta — o talão em si nunca vai pro Drive, conforme a Portaria 344/98",
      "🆕 Fotos, PDFs e áudios que o cliente manda no chat são arquivados sozinhos na pasta dele no Drive (01 - Recebidos no Chat), com a data no nome do arquivo — figurinhas ficam de fora",
      "Segurança: credenciais salvas nas configurações não são mais transmitidas em tempo real para as telas dos atendentes",
    ],
  },
  {
    version: "3.0.0",
    date: "2026-07-21",
    changes: [
      "🆕 Módulo Adesivos completo: cartela com várias artes numa folha (sem sobreposição), corte automático na Auto Cutter A3, contorno de recorte gerado automaticamente a partir da arte (die-cut), vetorização assistida de imagens, textos com 7 fontes e numeração sequencial/QR code/código de barras, templates de etiqueta reutilizáveis e variantes de cor automáticas",
      "🆕 Módulo Receituários (talão controlado ANVISA): modelos A, B, B2, Retinoides e Talidomida com numeração oficial, impressão em tira ou folha A4, lote de impressão por autorização — agora com um modelo 'Comum' para receituário simples sem faixa/autorização, pra quando não precisa ser talão controlado",
      "🆕 Sincronização bidirecional completa com o Bling: situação do pedido, dados e contatos aparecem no chat e se atualizam nos dois sentidos automaticamente",
      "🆕 Catálogo de produtos Bling com tabela de preços por faixa de quantidade — Orçamentos e Ordens de Serviço calculam o valor automaticamente pela quantidade",
      "🆕 Bot de atendimento guiado por menu no WhatsApp: reconhece pedidos numéricos, avisa quando não entendeu e coloca na fila de atendimento — reconhece fotos/PDFs como conteúdo (não como resposta a julgar), silencia quando um atendente já está no meio da conversa, aceita escolher mais de uma opção de uma vez (ex: '1 e 3') e confirma o recebimento quando o cliente manda os dados pedidos (nome, CRM, arte) em vez de dizer que não entendeu",
      "🆕 12 temas visuais novos (Oceano, Floresta, Sakura, Synthwave, Café, Candy, Gatinhos, Galáxia e outros) com seletor em grade e preview ao vivo — dois deles com decoração animada na tela",
      "Transcrição automática de áudio migrada para Groq Whisper (mais rápida e estável)",
      "Chat: responder citando mídia com preview, visualizador de imagem e de documentos (Word/PowerPoint/Excel) com impressão direta, selos de mensagem 'Encaminhada' e 'Enviado de dispositivo externo'",
      "Ordens de Serviço e Orçamentos: emissor automático, alerta de dados fiscais faltando, botão de enviar recibo de parcela paga direto no chat, alternância lista/grade",
      "Contatos: mesclar contatos duplicados e vínculo automático com o cadastro do Bling por telefone/CPF",
      "Aceite de orçamento agora pede o comprovante de pagamento (foto ou código da transação) antes de confirmar",
      "Painel de automação (n8n) para integrações externas via webhook",
      "Segurança: reforços de proteção de dados pessoais (LGPD) e correções de autorização em endpoints do Bling/Catálogo",
      "Marcador de 'Impresso' bem mais visível nas listas de Receituários e Ordens de Serviço",
      "Fix: receituário Retinoide não saía mais cortado nas bordas; corte da folha A4 ganhou margem de segurança",
      "Fix: reação a mensagens, preview de mídia recebida e áudio gravado voltando a funcionar de forma consistente",
      "Fix: WhatsApp não fica mais preso reconectando após reinício do servidor",
    ],
  },
  {
    version: "2.0.0",
    date: "2026-06-22",
    changes: [
      "🆕 Módulo Orçamentos: crie, envie e gerencie orçamentos com PDF, itens, validade, forma de pagamento e parcelamento — integrado ao chat",
      "🆕 Módulo Ordem de Serviço: abra OS diretamente de um ticket ou orçamento, com PDF profissional, marcas d'água (PAGO / A RECEBER / ACEITO / RECUSADO) e parcelamento 50/50 ou 3×",
      "🆕 Integração Bling ERP: sincronize pedidos de venda, busque contatos e catálogo de produtos direto da gaveta do contato — OAuth2 com renovação automática",
      "🆕 Aceite de orçamento com comprovante: ao aceitar um orçamento, o sistema pede foto do comprovante de pagamento ou código da transação antes de confirmar",
      "🆕 Transcrição automática de áudio: mensagens de voz recebidas são transcritas com IA (Groq Whisper) — ícone CC aparece no player para expandir o texto",
      "🆕 Reações a mensagens: reaja com emoji às mensagens — clique no ícone de reação no menu de contexto da mensagem",
      "Webhooks de saída: configure URLs externas para receber eventos em tempo real (mensagem enviada/recebida, ticket aberto/fechado)",
      "Relatórios: exporte histórico de atendimentos em CSV com filtros por período, fila e atendente; inclui tempo médio de atendimento",
      "Mesclar tickets: una dois tickets do mesmo contato em um só — histórico preservado",
      "Mensagens agendadas: programe envios para uma data e horário específicos",
      "Busca global: localize tickets, contatos e mensagens de qualquer tela pelo ícone 🔍 no topo",
      "Filtro por atendente na lista de tickets",
      "SLA configurável por fila — tempo máximo de resposta com alerta visual",
      "Horário de atendimento e mensagem de ausência automática por dia da semana",
      "Perfil WhatsApp: atualize nome, status e foto da conta WhatsApp diretamente pela tela de Conexões",
      "Labels do WhatsApp: veja as etiquetas de contato do WA exibidas na gaveta do contato",
      "Enviar contato (vCard): compartilhe um contato da agenda pelo chat usando o botão de anexo",
      "Catálogo de produtos Bling: pesquise e insira produtos do catálogo ao criar orçamentos e OS",
      "Histórico de atendimentos no drawer do contato: últimos tickets listados com data e status",
      "Rascunho automático aprimorado: texto digitado é salvo por ticket e restaurado ao voltar — funciona mesmo ao trocar de ticket rapidamente",
      "Chat abre sempre no final da conversa (mensagem mais recente visível ao abrir um ticket)",
      "Download de mídias em paralelo: até 3 mídias baixadas simultaneamente (antes era 1 por vez)",
      "Preview da lista atualiza ao terminar de baixar mídia (antes ficava mostrando '📥 Baixando mídia...')",
      "Fix: conexão WhatsApp não fica mais presa em 'Conectando' após reinício do servidor",
      "Fix: resolver ticket fechava corretamente mesmo quando havia usuário logado no ticket",
      "Fix: delay ao enviar arquivos eliminado (não aguarda mais confirmação de entrega do WA)",
      "Fix: campo de mensagem não trava mais ao colar texto longo",
      "Fix: tags exibidas corretamente dentro de menus (chips não ficam mais brancos)",
      "Fix: respostas rápidas com variável {{nome_atendente}} funcionando corretamente",
    ],
  },
  {
    version: "1.3.0",
    date: "2026-06-03",
    changes: [
      "Busca na conversa: botão 🔍 no chat abre campo de busca — encontra mensagens pelo texto, min 3 letras, até 100 resultados com destaque",
      "Alertas agendados: admin pode programar avisos com data e horário exatos — aparecem para todos na hora certa",
      "Identificação de origem: mensagens enviadas de celular fora do sistema aparecem com a etiqueta 'Enviado de dispositivo externo'",
      "Resolver ticket com mensagem rápida: ao resolver, opcional enviar uma resposta rápida de despedida direto pelo modal",
      "Auto-fechamento de tickets: tickets sem resposta fecham automaticamente após o período configurado nas Configurações",
      "Performance: envio de múltiplos arquivos de mídia em paralelo — significativamente mais rápido",
      "Preview de citação no campo de mensagem: ao responder, o balão de citação aparece acima do campo antes de enviar",
      "Auto-scroll ao chegar nova mensagem: botão flutuante para voltar ao final da conversa quando rolou para cima",
      "Rascunho automático: texto digitado no chat é salvo enquanto você navega entre tickets",
      "Ticket em atendimento destacado em verde na lista lateral",
      "Badge de não lidos: contador por aba (Fila Geral / Pessoal / Resolvidos) com total no título da página",
      "Performance: sistema de cache Redis para filas, configurações, conexões, tags, respostas rápidas e usuários — respostas até 10× mais rápidas nas telas de listagem",
      "Estabilidade: QR Code expira após 3 minutos sem escanear — Chrome para automaticamente (antes ficava rodando indefinidamente consumindo CPU)",
      "Fix: acentuação normalizada (NFD→NFC) — mensagens com caracteres especiais chegam corretas",
      "Fix: controle de acesso por perfil revisado em todas as rotas",
      "Fix: notificação de transferência enviada para o novo responsável em tempo real",
    ],
  },
  {
    version: "1.2.4",
    date: "2026-05-20",
    changes: [
      "Legenda de mídia: escreva uma legenda ao enviar fotos, vídeos e documentos",
      "Múltiplos arquivos: envie até 5 arquivos de uma vez com preview de miniaturas antes de enviar",
      "Assumir ticket abre direto o chat (antes ficava parado na listagem)",
      "Resolver e Transferir ticket direto da lista — sem precisar abrir o chat",
      "Transferir para fila sem atribuir agente (antes era obrigatório escolher um atendente)",
      "Avatar do agente nas notas internas — aviso interno mostra a foto do usuário que escreveu",
      "Imagens enviadas de celular externo (não pelo sistema) chegam corretamente no chat",
      "Banner 'Assumir Ticket/Atendimento' reposicionado acima das mensagens — mais visível quando o ticket está na fila ou com outro agente",
      "Fix: reações a mensagens chegam em tempo real para todos os agentes (bug de socket room resolvido)",
      "Fix: balão de citação não desaparecia mais após confirmação de entrega (ACK)",
      "Fix: badges de contagem nas abas atualizando em tempo real (antes precisava F5)",
    ],
  },
  {
    version: "1.2.3",
    date: "2026-05-18",
    changes: [
      "Indicador de digitação do cliente: quando o contato WhatsApp está digitando, aparece 'Cliente está digitando...' em verde acima do campo de mensagem",
      "Fix: apagar e editar mensagens no WhatsApp funcionando (bug do JID @lid resolvido — WhatsApp multi-device usa formato interno diferente do número de telefone)",
      "Fix: mensagens chegando em ordem correta mesmo com timestamps fora de sequência",
      "Fix: aba Buscar não mostra mais tickets aleatórios em tempo real (resultados são estáticos)",
      "Evolution API removida do servidor (não era mais utilizada)",
    ],
  },
  {
    version: "1.2.2",
    date: "2026-05-16",
    changes: [
      "Detecção automática de nova versão: banner laranja aparece para todos os usuários em até 5 minutos após um deploy, com botão 'Atualizar agora' — sem precisar de Ctrl+Shift+R",
      "Fix: aviso do admin para todos corrigido (rota /admin/alerts não estava no proxy do Nginx — erro 405)",
      "Mapeamento completo do projeto salvo na memória do assistente para consultas rápidas",
    ],
  },
  {
    version: "1.2.1",
    date: "2026-05-16",
    changes: [
      "Avisos para todos: admin pode escrever título + mensagem e enviar para a sininha de notificações de todos os usuários em tempo real",
    ],
  },
  {
    version: "1.2.0",
    date: "2026-05-16",
    changes: [
      "Fundo de chat personalizável — paleta de cores e upload de imagem própria por usuário",
      "Tags globais corrigidas — bug do Vite transformava '/tags/global' em '/tags/globalThis' (HTTP 404)",
      "Tags: seletor com Autocomplete, sugestões de tags existentes e criação de novas com color picker",
      "Kanban: colunas dinâmicas por fila (queue) com alternância fila/atendente e drag & drop",
      "Drag & drop de arquivos diretamente na conversa",
      "Sync de histórico: buscar até 500 mensagens com barra de progresso em tempo real",
      "Reações a mensagens: suporte a emoji reactions do WhatsApp",
      "Encaminhar mensagem entre tickets",
      "Suporte completo de mídia: player de áudio estilo WhatsApp, preview de PDF/vídeo/documentos",
      "Modo noturno: 4 temas (Claro, Escuro, Alto Contraste, Corporativo)",
      "Fila Geral: visualizar chat de tickets pendentes + botão 'Assumir Ticket' com proteção contra race condition",
      "Indicador de digitação entre agentes no mesmo ticket",
      "Botão de importação WhatsApp removido (prevenia crash do servidor em agendas grandes)",
      "Tags globais: painel de gerenciamento para admin",
      "Importação de contatos via CSV com mapeamento de colunas",
      "Estabilidade: WhatsApps inicializam em sequência no startup (sem pico de RAM)",
      "Estabilidade: gravação de áudio isolada por componente (sem estado global)",
      "Notificações: posição corrigida, limite de 5 simultâneas, foco na última",
      "Tickets resolvidos: reabrem o ticket existente ao receber nova mensagem (sem duplicatas)",
      "Erro de sessão expirada no F5 eliminado via refresh silencioso por cookie HttpOnly",
    ],
  },
  {
    version: "1.0.0",
    date: "2026-05-15",
    changes: [
      "🎉 Versão 1.0.0 estável — sistema aprovado para produção",
      "QR Code: formato URL corrigido (wa.me/settings/linked_devices) — celulares modernos leem corretamente",
      "QR Code: contador regressivo real com barra de progresso, aviso em vermelho nos últimos 5s",
      "Sessão WhatsApp: reconexão automática com backoff exponencial e proteção contra loop infinito",
      "Sessão WhatsApp: listeners duplicados eliminados com controle de geração (stale listener fix)",
      "Sessão WhatsApp: tickets órfãos (whatsappId=null) reatribuídos automaticamente ao reconectar",
      "Mensagens: erro ao citar mensagem antiga (ForeignKeyConstraintError) corrigido",
      "Mensagens: getProfilePicUrl não bloqueia mais o processamento em caso de timeout do Chrome",
      "Performance: syncRecentMessages inicia 60s após conexão para não saturar o Chrome no startup",
      "Performance: delay de 3s entre tickets no sync evita ProtocolError por sobrecarga do Puppeteer",
      "Docker: rebuild do frontend não reinicia mais o backend (depends_on removido)",
      "Docker: healthcheck no backend — Docker reinicia automaticamente se o serviço travar",
      "Importação de contatos: roda em background sem bloquear o sistema ou o Chrome",
      "Página de Tags: gerenciamento completo de tags para contatos",
    ],
  },
  {
    version: "0.4.12",
    date: "2026-05-12",
    changes: [
      "Importação de contatos: reescrita com paginação — busca 100 contatos por vez, sem timeout, roda em background",
      "Importação de contatos: botão 'Importar' retorna imediatamente com toast de confirmação",
    ],
  },
  {
    version: "0.4.11",
    date: "2026-05-12",
    changes: [
      "Estabilidade: memory leak corrigido — listeners do WhatsApp agora são removidos corretamente a cada reconexão",
      "Estabilidade: reconexão do WhatsApp usa backoff exponencial (2s → 4s → 8s... máx 5min) — evita loop de crash",
      "Estabilidade: health check no backend — Docker detecta se o serviço travou e reinicia automaticamente",
      "Estabilidade: race condition em criação de tickets corrigida com transaction + lock — elimina tickets duplicados em mensagens simultâneas",
      "Dashboard admin/supervisor: novo card 'Aguardando +1h' mostra clientes sem atendimento há mais de 1 hora",
    ],
  },
  {
    version: "0.4.10",
    date: "2026-05-12",
    changes: [
      "Excluir contatos: botão visível para todos os perfis (não apenas admin/supervisor)",
      "Correção: exclusão de contato remove da lista imediatamente, sem precisar de F5",
      "Foto de perfil: imagem redimensionada para no máximo 256×256 antes de salvar (evita sobrecarga no banco)",
      "Correção crítica: salvar foto de perfil não remove mais o atendente das filas atribuídas",
      "Kanban: cartão exibe número de telefone do contato abaixo do nome",
      "Modo escuro: preferência salva no navegador — persiste entre sessões",
      "Modo escuro: tema completo com cores KR (fundo #1A1A1A, paper #242424, scrollbar laranja)",
      "Modo escuro: sidebar, conteúdo e rodapé seguem o tema corretamente",
    ],
  },
  {
    version: "0.4.9",
    date: "2026-05-12",
    changes: [
      "Correção: Card 'Resolvidos Hoje' no Dashboard agora conta corretamente apenas tickets fechados (antes contava todos os tickets do dia independente do status)",
      "Dashboard admin/supervisor: contador 'Resolvidos Hoje' usa data de fechamento real (updatedAt) em vez de data de criação do ticket",
      "Correção: gráfico de tickets por hora mantém visão global da empresa após o fix de filtros",
      "Performance: índices de banco adicionados nas tabelas Tickets e Messages (consultas até 10x mais rápidas com volume alto de atendimentos)",
      "Estabilidade: pool de conexões com banco ampliado de 5 para 20 conexões simultâneas",
    ],
  },
  {
    version: "0.4.8",
    date: "2026-05-11",
    changes: [
      "Foto de perfil: faça upload de avatar no modal de perfil — aparece no botão do menu superior",
      "Alerta de espera: aviso sonoro + toast quando há clientes aguardando ha mais de 1 hora na Fila Geral (verifica a cada 2 minutos)",
      "Correção: tela de tickets nao travava mais ao abrir (ReferenceError: Cannot access before initialization)",
    ],
  },
  {
    version: "0.4.7",
    date: "2026-05-11",
    changes: [
      "Correção: avisos internos agora aparecem em tempo real sem precisar de F5",
      "Avisos internos mostram o nome de quem escreveu (ex: 'João: Transferido para...')",
      "Alerta: toast a cada 5 minutos quando o WhatsApp está desconectado",
      "Badge da aba Pessoal agora só aparece quando há mensagens não lidas (não conta tickets silenciosos)",
    ],
  },
  {
    version: "0.4.6",
    date: "2026-05-11",
    changes: [
      "Correção: envio de áudio voltou a funcionar — gravações consecutivas não falham mais (reset do recorder após cada envio)",
      "Correção: áudio muito curto agora exibe aviso em vez de falhar silenciosamente",
      "Botão ⚡ Respostas Rápidas no chat: abre modal com busca por texto ou atalho, clique insere diretamente no campo",
      "Correção: busca de respostas rápidas agora encontra por atalho (shortcut) além do texto da resposta",
      "Dashboard por perfil: agentes veem Minha Fila / Fila Geral / Resolvidos Hoje; admins veem totais gerais",
      "Dashboard admin/supervisor: nova seção 'Desempenho Hoje' com tickets fechados e tempo médio por atendente",
      "Kanban: colunas renomeadas para 'Fila Geral' e 'Atendendo' alinhando com nova terminologia",
      "Kanban: arrastar da Fila Geral para Atendendo agora atribui o ticket ao usuário que arrastou (pull model)",
      "Kanban: arrastar ticket de volta para Fila Geral remove a atribuição de atendente",
      "Kanban: atualização em tempo real via socket — tickets movem-se entre colunas automaticamente",
      "Kanban: agentes veem apenas seus próprios tickets na coluna Atendendo",
      "Correção: logs de atividade de usuário agora visíveis quando a migration não rodou (erro não mais silenciado)",
    ],
  },
  {
    version: "0.4.5",
    date: "2026-05-11",
    changes: [
      "Fila Geral: nova aba mostrando todos os tickets pendentes sem atendente — qualquer agente pode assumir com um clique",
      "Fila Pessoal: substitui o 'Inbox' mostrando apenas os tickets atribuídos ao usuário logado",
      "Correção: ticket transferido some da fila do atendente anterior em tempo real (sem precisar recarregar)",
      "Correção: ticket assumido da Fila Geral desaparece corretamente após ser puxado",
    ],
  },
  {
    version: "0.4.4",
    date: "2026-05-11",
    changes: [
      "Modo Observador: admins/supervisores podem abrir qualquer ticket em modo somente leitura, ver mensagens em tempo real e assumir o atendimento com um clique",
    ],
  },
  {
    version: "0.4.3",
    date: "2026-05-11",
    changes: [
      "Correção: F5 em qualquer página agora carrega o app corretamente (nginx detecta navegação vs chamada API)",
      "Correção: WebSocket não abre mais múltiplas conexões em série durante navegação entre páginas",
      "Correção: permissão de notificação solicitada apenas no primeiro clique, não automaticamente",
    ],
  },
  {
    version: "0.4.2",
    date: "2026-05-11",
    changes: [
      "Correção: página de Contatos não trava mais com erro ao carregar tags",
      "Correção: busca de contatos com tag associada retornava erro 500 (coluna ambígua no banco)",
    ],
  },
  {
    version: "0.4.1",
    date: "2026-05-11",
    changes: [
      "Correção: sessão não expira mais inesperadamente durante uso normal (JWT 15m → 24h)",
      "Correção: token de sessão agora é renovado e salvo corretamente no armazenamento local",
      "Correção: flood de conexões WebSocket eliminado com padrão singleton + debounce",
    ],
  },
  {
    version: "0.4.0",
    date: "2026-05-11",
    changes: [
      "Conexões: botões de conectar/desconectar/editar/excluir restritos a administradores",
      "Transferência de ticket: ticket vai automaticamente para 'Aguardando' no destinatário",
      "Filas: admin e supervisor veem todas as filas disponíveis no filtro de tickets",
      "QR Code: toast de sucesso ao conectar + contador regressivo de expiração do QR",
      "Contatos: filtro por tag e por data de criação",
      "Contatos: seleção múltipla com exclusão em massa",
      "Contatos: detecção e remoção de contatos com número duplicado",
      "Contatos: importação de contatos via arquivo CSV com mapeamento de colunas",
      "Avisos internos: mensagens visíveis apenas para a equipe, não enviadas ao cliente",
      "Auto-avisos: nota automática ao transferir ticket e ao finalizar atendimento",
    ],
  },
  {
    version: "1.1.0",
    date: "2025-05-01",
    changes: [
      "Redesign visual completo com identidade KR Gráfica",
      "Novo logo e paleta de cores oficial (laranja #F37021)",
      "Dashboard renovado com cards de métricas",
      "Login com painel dividido e animações",
      "Bolhas de mensagens com estilo moderno",
    ],
  },
  {
    version: "1.0.0",
    date: "2025-04-01",
    changes: [
      "Lançamento inicial do ChatKR",
      "Atendimento via WhatsApp com múltiplos agentes",
      "Gerenciamento de filas e setores",
      "Respostas rápidas",
      "Notificações em tempo real",
    ],
  },
];

export default changelog;
